export const SUBMIT_MERCHANT_REGISTRATION = 'SUBMIT_MERCHANT_REGISTRATION';
export const SUBMIT_MERCHANT_REGISTRATION_SUCCESS = 'SUBMIT_MERCHANT_REGISTRATION_SUCCESS';
export const SUBMIT_MERCHANT_REGISTRATION_FAILURE = 'SUBMIT_MERCHANT_REGISTRATION_FAILURE';
export const CLEAR_MERCHANT_REGISTRATION_ERROR = 'CLEAR_MERCHANT_REGISTRATION_ERROR';
export const SET_SOURCE_PACKAGE_ID = 'SET_SOURCE_PACKAGE_ID';
export const CLEAR_SOURCE_PACKAGE_ID = 'CLEAR_SOURCE_PACKAGE_ID';

export const SUBMIT_ADMINISTRATIVE_BILLING_DETAILS = 'SUBMIT_ADMINISTRATIVE_BILLING_DETAILS';
export const SUBMIT_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS = 'SUBMIT_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS';
export const SUBMIT_ADMINISTRATIVE_BILLING_DETAILS_FAILURE = 'SUBMIT_ADMINISTRATIVE_BILLING_DETAILS_FAILURE';
export const CLEAR_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS = 'CLEAR_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS';

export const GET_ADMINISTRATIVE_BILLING_DETAILS = 'GET_ADMINISTRATIVE_BILLING_DETAILS';
export const GET_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS = 'GET_ADMINISTRATIVE_BILLING_DETAILS_SUCCESS';
export const GET_ADMINISTRATIVE_BILLING_DETAILS_FAILURE = 'GET_ADMINISTRATIVE_BILLING_DETAILS_FAILURE';

export const SEND_CONTRACT_OTP = 'SEND_CONTRACT_OTP';
export const SEND_CONTRACT_OTP_SUCCESS = 'SEND_CONTRACT_OTP_SUCCESS';
export const SEND_CONTRACT_OTP_FAILURE = 'SEND_CONTRACT_OTP_FAILURE';
export const CLEAR_SEND_CONTRACT_OTP_SUCCESS = 'CLEAR_SEND_CONTRACT_OTP_SUCCESS';

export const VERIFY_CONTRACT_OTP = 'VERIFY_CONTRACT_OTP';
export const VERIFY_CONTRACT_OTP_SUCCESS = 'VERIFY_CONTRACT_OTP_SUCCESS';
export const VERIFY_CONTRACT_OTP_FAILURE = 'VERIFY_CONTRACT_OTP_FAILURE';
export const CLEAR_VERIFY_CONTRACT_OTP_SUCCESS = 'CLEAR_VERIFY_CONTRACT_OTP_SUCCESS';

export const GET_CONTRACT = 'GET_CONTRACT';
export const GET_CONTRACT_SUCCESS = 'GET_CONTRACT_SUCCESS';
export const GET_CONTRACT_FAILURE = 'GET_CONTRACT_FAILURE';

export const GET_MERCHANT_PAYMENT_REQUIRED_INFO = 'GET_MERCHANT_PAYMENT_REQUIRED_INFO';
export const GET_MERCHANT_PAYMENT_REQUIRED_INFO_SUCCESS = 'GET_MERCHANT_PAYMENT_REQUIRED_INFO_SUCCESS';
export const GET_MERCHANT_PAYMENT_REQUIRED_INFO_FAILURE = 'GET_MERCHANT_PAYMENT_REQUIRED_INFO_FAILURE';

export const VERIFY_MERCHANT_CHECKOUT_SESSION = 'VERIFY_MERCHANT_CHECKOUT_SESSION';
export const VERIFY_MERCHANT_CHECKOUT_SESSION_SUCCESS = 'VERIFY_MERCHANT_CHECKOUT_SESSION_SUCCESS';
export const VERIFY_MERCHANT_CHECKOUT_SESSION_FAILURE = 'VERIFY_MERCHANT_CHECKOUT_SESSION_FAILURE';
export const CLEAR_MERCHANT_CHECKOUT_VERIFY_SESSION = 'CLEAR_MERCHANT_CHECKOUT_VERIFY_SESSION';
